/* import __COLOCATED_TEMPLATE__ from './empty-state.hbs'; */
/* RESPONSIBLE TEAM: team-inbox */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Args: any;
}

const EmptyState = templateOnlyComponent<Signature>();
export default EmptyState;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::Dashboard::EmptyState': typeof EmptyState;
    'inbox2/dashboard/empty-state': typeof EmptyState;
  }
}
